export const actionType = {
    SET_USER : 'SET_USER',
    SET_ACC : 'SET_ACC',
    SET_SUCCESS : 'SET_SUCCESS',
    SET_ERROR : 'SET_ERROR',
    SET_REF : 'SET_REF',
}


const reducer = (state, action) => {
    console.log(action)
    switch(action.type) {
        case actionType.SET_USER:
            return {
                ...state,
                user: action.user,
            };
        case actionType.SET_ACC:
            return {
                ...state,
                account: action.account,
            }
        case actionType.SET_SUCCESS:
            return {
                ...state,
                success: action.success,
            }  
        case actionType.SET_ERROR:
            return {
                ...state,
                error: action.error,
            } 
        case actionType.SET_REF:
            return {
                ...state,
                refAddress: action.refAddress,
            }         
        
        default:
            return state;    
    }
};

export default reducer;